import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';


@Component({
  selector: 'app-esco',
  templateUrl: './esco.component.html',
  styleUrls: ['./esco.component.css']
})
export class EscoComponent implements OnInit {

  constructor(
    private router: Router,
    public afAuth: AngularFireAuth) { }
  logout() {
    return this.afAuth
       .auth
       .signOut().then(() => {
this.router.navigate(['/']);
       });
   }
  ngOnInit() {
  }

}
